export const BETTING_PROMOTION = {
  ACTION_TYPES: {
    onPopupClick: 'onPopupClick',
    bettingPromotionCounter: 'bettingPromotionCounter',
    ANALYTICS: {
      onDisplayHandler: 'onDisplayHandler',
      onClickHandler: 'onClickHandler'
    }
  },

  TYPES: {
    popup: 'popup',
    banner: 'banner'
  },

  DEVICES: {
    mobile: '_mobile',
    desktop: '_desktop'
  },

  CLICK_TYPE: {
    clear: -1,
    link: 1,
    later: 2,
    notInterested: 3
  },

  POPUP_IMAGE_SIZE: {
    width: 468,
    height: 266
  },

  BOOKIE_LOGO: {
    ratio: 3.2,
    minHeight: 32,
    maxHeight: 40
  },

  LINKS: {
    POPUP: {
      desktop: 'https://mediaserver.entainpartners.com/renderBanner.do?zoneId=2126645&tdpeh=Context-BWP_Platform-Desktop_Version-A_OS-Web_$GUID_ga4clientid-$GA_CLIENT_ga4sessionidRLK-$GA4_SESSION&btag=301645',
      mobile: 'https://mediaserver.entainpartners.com/renderBanner.do?zoneId=2126645&tdpeh=Context-BWP_Platform-Mobile_Version-A_OS-Web_$GUID_ga4clientid-$GA_CLIENT_ga4sessionidRLK-$GA4_SESSION&btag=301645'
    },

    BANNER: {
      desktop: 'https://mediaserver.entainpartners.com/renderBanner.do?zoneId=2126645&tdpeh=Context-BWP_Platform-Desktop_Version-B_OS-Web_$GUID_ga4clientid-$GA_CLIENT_ga4sessionidRLK-$GA4_SESSION&btag=301645',
      mobile: 'https://mediaserver.entainpartners.com/renderBanner.do?zoneId=2126645&tdpeh=Context-BWP_Platform-Mobile_Version-B_OS-Web_$GUID_ga4clientid-$GA_CLIENT_ga4sessionidRLK-$GA4_SESSION&btag=301645'
    },
  },
  UTM_MODULE_ID: 'BP',
  UTM_ID_PARAM: 'utm_id'
};
